import {defineStore} from 'pinia';
import type {Customer} from '~/modules/GraphQL/types';

interface CustomerState {
  user: Customer,
  isLoggedIn: boolean,
  addresses: any[],
  customerData: {
    firstname: string,
    lastname: string,
  },
  billingAddress: {
    default_billing: boolean,
    default_shipping: boolean,
    company: string,
    firstname: string,
    lastname: string,
    street: string[],
    city: string,
    postcode: string,
    country_id: string,
    telephone: string,
  },
  shippingAddress: {
    default_billing: boolean,
    default_shipping: boolean,
    company: string,
    firstname: string,
    lastname: string,
    street: string[],
    city: string,
    postcode: string,
    country_id: string,
    telephone: string,
  }
  groupId: string | null,
}

export const useCustomerStore = defineStore('customer', {
  state: (): CustomerState => ({
    user: null,
    isLoggedIn: false,
    addresses: [],
    groupId: null,
    customerData: {
      firstname: '',
      lastname: '',
    },
    billingAddress: {
      default_billing: true,
      default_shipping: false,
      company: '',
      firstname: '',
      lastname: '',
      street: [''],
      city: '',
      postcode: '',
      country_id: '',
      telephone: '',
    },
    shippingAddress: {
      default_billing: false,
      default_shipping: true,
      company: '',
      firstname: '',
      lastname: '',
      street: [''],
      city: '',
      postcode: '',
      country_id: '',
      telephone: '',
    },
  }),
  actions: {
    setIsLoggedIn(isLoggedIn: boolean) {
      this.isLoggedIn = isLoggedIn;
    },
    setAddresses(addresses: []) {
      this.addresses = addresses;
    },
    setGroupId(groupId: string) {
      this.groupId = groupId;
    },
    setCustomerData(customerData: any) {
      this.customerData = customerData;
    },
    setUser(user: Customer) {
      window.localStorage.setItem('user', JSON.stringify(user));
      this.user = user;
    },
    getUser() {
      const user = window.localStorage.getItem('user');
      if (user) {
        return JSON.parse(user);
      }
      return null;
    },
    clearUser() {
      window.localStorage.removeItem('user');
      this.user = null;
    },
    setBillingAddress(address: any) {
      this.billingAddress = address;
    },
    setShippingAddress(address: any) {
      this.shippingAddress = address;
    }
  },
});
